export enum ContactType {
  home = 0,
  mobile = 1,
  work = 2,
  emergency = 3,
  caregiver = 4,
}
